import { ComparisonResultData } from '../infrastructure/models';

export const toCamelCaseKey = (key: string): string =>
    key.charAt(0).toLowerCase() + key.slice(1);

export const toCamelCaseDeep = (obj: unknown): unknown => {
    if (Array.isArray(obj)) return obj.map(toCamelCaseDeep);
    if (obj !== null && typeof obj === 'object') {
        return Object.fromEntries(
            Object.entries(obj as Record<string, unknown>).map(([k, v]) => [
                toCamelCaseKey(k),
                toCamelCaseDeep(v),
            ]),
        );
    }
    return obj;
};

export const parseResultJson = (raw: string | null): ComparisonResultData | null => {
    if (!raw) return null;
    try {
        const parsed = JSON.parse(raw);
        return toCamelCaseDeep(parsed) as ComparisonResultData;
    } catch {
        return null;
    }
};
